import ReactDOM from "react-dom";
import h from "h";
import PricingTable from "./PricingTable";
export default function initPricing(node, props) {
  ReactDOM.render(h(PricingTable, props), node);
}
